import api from '@/api/employeeManagement'

const state = {
}

const actions = {
  getEmployeeList (context, params) {
    return api.getEmployeeList(params)
  },
  updateCompanyRegisterStatus (context, params) {
    return api.updateCompanyRegisterStatus(params)
  },
  updateEmployeeStatus (context, params) {
    return api.updateEmployeeStatus(params)
  },
  updateEmailSuffix (context, params) {
    return api.updateEmailSuffix(params)
  },
  getUploadEmployeeResult (context, params) {
    return api.getUploadEmployeeResult(params)
  },
  uploadEmployee (context, file) {
    return api.uploadEmployee(file)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
